"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FinanceProductNamesTypes;
(function (FinanceProductNamesTypes) {
    FinanceProductNamesTypes["CASH"] = "CASH";
})(FinanceProductNamesTypes = exports.FinanceProductNamesTypes || (exports.FinanceProductNamesTypes = {}));
